import PropTypes from 'prop-types';
import { START_DATE, END_DATE } from 'react-dates/constants';
import { LABEL, OPTION } from './FiltersContainer.constants';

export const labels = PropTypes.shape(
  Object.entries(LABEL)
    .map(entry => entry[1])
    .reduce((obj, key) => ({ ...obj, [key]: PropTypes.string }), {})
);

export const buttons = PropTypes.shape({
  icon: PropTypes.string,
  label: PropTypes.string,
  layerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool
});

export const propTypes = {
  labels,
  selectedOption: PropTypes.oneOf([...Object.keys(OPTION).map(key => OPTION[key]), '']),
  showPanel: PropTypes.bool,
  inset: PropTypes.number,
  showBackdrop: PropTypes.bool,
  onMobilePanelClose: PropTypes.func,
  onPanelButtonClick: PropTypes.func,
  onBackdropClick: PropTypes.func,

  // Dates
  labelStartDate: PropTypes.string,
  labelEndDate: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  dateProps: PropTypes.shape(),
  focusedDateInput: PropTypes.oneOf([START_DATE, END_DATE]),
  onUpdateDatesButtonClick: PropTypes.func,
  onDatesChange: PropTypes.func,
  onResetButtonClick: PropTypes.func,
  onApplyButtonClick: PropTypes.func,

  // Rooms
  numRooms: PropTypes.string,
  numRoomsLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  roomsInputProps: PropTypes.shape(),
  onRoomButtonClick: PropTypes.func,
  onRoomsValueChange: PropTypes.func,

  // Filters
  numFilters: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  propertyTypes: PropTypes.arrayOf(buttons),
  distance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  distanceUnitBefore: PropTypes.string,
  distanceUnitAfter: PropTypes.string,
  location: PropTypes.string,
  distanceMin: PropTypes.number,
  distanceMax: PropTypes.number,
  priceRangeMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  priceRangeMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  priceRangeSliderMin: PropTypes.number,
  priceRangeSliderMax: PropTypes.number,
  priceRangeStartIcon: PropTypes.string,
  priceRangeEndIcon: PropTypes.string,
  amenities: PropTypes.arrayOf(buttons),
  shouldInstantBook: PropTypes.bool,
  showSeeMore: PropTypes.bool,
  onClearButtonClick: PropTypes.func,
  onUpdateFiltersButtonClick: PropTypes.func,
  onInstantBookToggle: PropTypes.func,
  onAmenityClick: PropTypes.func,
  onSeeMoreClick: PropTypes.func,
  onPriceRangeChangeSlider: PropTypes.func,
  onPriceRangeChangeInput: PropTypes.func,
  onDistanceChangeSlider: PropTypes.func,
  onDistanceChangeInput: PropTypes.func,
  onPropertyClick: PropTypes.func,
  hideInstantBook: PropTypes.bool,
  distanceProps: PropTypes.shape()
};
